import "reflect-metadata";
import Vue from "vue";
import store from "@/store";
import router from "@/router";
import i18n from "@/i18n";
import App from "@/App.vue";
import { setup } from "@/setup";

setup();

new Vue({
  router,
  store,
  render: (h) => h(App),
  i18n,
}).$mount("#app");
